/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class CloudTypenName {
    public static readonly SEMINARE_SEMINAREKATEGORIE_NAME = "Seminare_SeminareKategorie";
    public static readonly SEMINARE_SEMINAR_NAME = "Seminare_Seminar";
    public static readonly SEMINARE_SEMINARREIHE_NAME = "Seminare_Seminarreihe";
    public static readonly SEMINARE_SEMINARTEXTE_NAME = "Seminare_Seminartexte";
    public static readonly SEMINARE_SEMINAR_TEAMS_EINSTELLUNGEN_NAME = "Seminare_SeminarTeamsEinstellungen";
    public static readonly SEMINARE_SEMINAR_ZOOM_EINSTELLUNGEN_NAME = "Seminare_SeminarZoomEinstellungen";
    public static readonly SEMINARE_SEMINAREVALUATION_NAME = "Seminare_LadeSeminarevaluation_Seminarevaluation";
    public static readonly TEILNAHMEN_TEILNAHME_NAME = "Teilnahmen_Teilnahme";
    public static readonly TEILNAHMEN_ADRESSE_NAME = "Teilnahmen_Adresse";
    public static readonly TEILNAHMEN_LEISTUNG_NAME = "Teilnahmen_Leistung";
    public static readonly TEILNAHMEN_TEILNAHMELISTENPOSITION = "Teilnahmen_Teilnahmelistenposition";
    public static readonly TEILNAHMEN_TEILNAHMELISTE = "Teilnahmen_Teilnahmeliste";
    public static readonly BELEGE_BELEG = "Belege_Beleg";
    public static readonly BELEGE_BELEGPOSITION = "Belege_Belegposition";
    public static readonly BELEGE_FIBUEXPORT = "Belege_FibuExport";
    public static readonly TEILNAHMEN_BESTELLUNG = "Teilnahmen_Bestellung";
    public static readonly TEILNAHMEN_BESTELLPOSITION = "Teilnahmen_Bestellposition";
    public static readonly TEILNAHMEN_BESTELLTERARTIKEL = "Teilnahmen_BestellterArtikel";
    public static readonly ADRESSEN_ADRESSENKATEGORIE = "Adressen_AdressenKategorie";
    public static readonly ADRESSEN_ADRESSE = "Adressen_Adresse";
    public static readonly DOKUMENTE_TEILNAHMEZERTIFIKAT = "Dokumente_TeilnahmeZertifikat";
    public static readonly DOKUMENTE_SEMINARDOZIERENDZERTIFIKAT = "Dokumente_SeminarDozierendZertifikat";
    public static readonly PAYMENTS_ANFECHTUNG = "Payments_Anfechtung";
    public static readonly RESSOURCEN_RESSOURCE = "Ressourcen_Ressource";
    public static readonly RESSOURCEN_KATEGORIE = "Ressourcen_Kategorie";
    public static readonly RESSOURCEN_BELEGUNG = "Ressourcen_Belegung";
    public static readonly DOKUMENTE_EMAIL = "Dokumente_EMail";
    public static readonly EXPORTE_CSVEXPORT = "Exporte_CsvExport";
    public static readonly IMPORTE_CSVIMPORT = "Importe_CsvImport";
    public static readonly MAHLZEITEN_MAHLZEIT = "Mahlzeiten_Mahlzeit";
    public static readonly TEILNAHMEN_REGEL = "Teilnahmen_Regelliste_Regel";
}